<template>
  <div>
    <modal-incident-create />
    <modal-incident-update :data="this.data_row" :stateArray="this.stateArray" />

    <div
      class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">Overview</h6>
            <h2 class="text-black text-xl font-semibold">Incidents - Data Table</h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <div class="relative">
          <vue-good-table
            :columns="columns"
            :lineNumbers="true"
            :rows="data_incident_table"
            @on-row-click="onRowClick"
            :search-options="{
              enabled: true,
              placeholder: 'Search Incident'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No incidents available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="data_incident_table"
                type="button"
                name="data_incident_table.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
            <div slot="table-actions-bottom">
              <button
                @click="createIncident"
                class="uppercase bg-blue-500 hover:bg-blue-700 text-white w-full font-bold py-2 px-4 rounded"
              >
                Create new Incident
              </button>
            </div>
          </vue-good-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: CardIncidentsTable
  Description: This class representing a table with loaded incidents.
*/

/* Imports */
import ModalIncidentCreate from "@/components/Modals/Incidents/ModalIncidentCreate.vue";
import ModalIncidentUpdate from "@/components/Modals/Incidents/ModalIncidentUpdate.vue";
/* /Imports/ */

export default {
  /* 
    Define data with custom incidents state values.
   */
  data() {
    return {
      dataIncidents: null,
      dataUser: null,
      data_incident_table: [],
      data_row: null,
      stateArray: [
        { value: "New", label: "New" },
        { value: "In Progress", label: "In Progress" },
        { value: "On Hold", label: "On Hold" },
        { value: "Resolved", label: "Resolved" },
        { value: "Closed", label: "Closed" },
        { value: "Canceled", label: "Canceled" },
        { value: "Awaiting User Info", label: "Awaiting User Info" },
      ],
      columns: [
        {
          label: "Number",
          field: "number",
          filterable: true,
        },
        {
          label: "Category Name",
          field: "category_name",
          filterable: true,
        },
        {
          label: "Short Description",
          field: "short_description",
          filterable: true,
        },
        {
          label: "Description",
          field: "description",
          filterable: true,
        },
        {
          label: "Caller",
          field: "caller",
          filterable: true,
        },
        {
          label: "Executor",
          field: "executor",
          filterable: true,
        },
        {
          label: "State",
          field: "state",
          filterable: true,
        },
        {
          label: "Impact",
          field: "impact",
          filterable: true,
        },
        {
          label: "Urgency",
          field: "urgency",
          filterable: true,
        },
        {
          label: "Priority",
          field: "priority",
          filterable: true,
        },
        {
          label: "Created",
          field: "created_at",
          filterable: true,
        },
        {
          label: "Updated",
          field: "updated_at",
          filterable: true,
        },
      ],
      rows: this.data_incident_table,
    };
  },

  /* 
    Define different components for reusability. 
  */
  components: {
    ModalIncidentCreate,
    ModalIncidentUpdate
  },

  /* 
    Define methods for separate different logic.
  */
  methods: {
    /* 
      Show modal for create new incident.
     */
    createIncident() {
      this.$modal.show("incident-create");
    },

    /* 
      Show modal for single incident. 
    */
    onRowClick(params) {
      this.data_row = params.row;
      this.$modal.show("incident-update");
    },

    /* 
      We got all incidents and save them to state. 
    */
    getIncidents() {
      this.$store.dispatch("incidentTable/getAllIncidents").then(() => {
        this.dataIncidents = this.$store.state.incidentTable.incidentData;

        for (var i = 0; i < this.dataIncidents.length; i++) {
          this.data_incident_table.push({
            id: this.dataIncidents[i].id,
            number: "INC" + this.dataIncidents[i].number,
            category_name: this.dataIncidents[i].category_id[0].name,
            short_description: this.dataIncidents[i].short_description,
            description: this.dataIncidents[i].description,
            caller:
              this.dataIncidents[i].caller[0].first_name +
              " " +
              this.dataIncidents[i].caller[0].last_name,
            executor:
              this.dataIncidents[i].executor[0].first_name +
              " " +
              this.dataIncidents[i].executor[0].last_name,
            state: this.dataIncidents[i].state,
            impact: this.dataIncidents[i].impact,
            urgency: this.dataIncidents[i].urgency,
            priority: this.dataIncidents[i].priority,
            created_at: this.dataIncidents[i].created_at,
            updated_at: this.dataIncidents[i].updated_at,
            token_caller: this.dataIncidents[i].caller[0].token,
            token_executor: this.dataIncidents[i].executor[0].token,
          });
        }

      });
    }
  },

  /* 
    Load all incidents after the instance. 
  */
  mounted() {
    this.getIncidents();
  },
};
</script>
